import React, { useState, useEffect } from "react";
import CollapseButton from "../../../utilities/CollapseButton/CollapseButton";
import {
  transactionType,
  actionDescription,
} from "../../Page/TransactionSummaryPage/Shared/Constants";
import {
  setPriceCyclesDescription,
  checkSectionValid,
  checkRegularPayment,
  setStatusStyle,
} from "../../Page/TransactionSummaryPage/Shared/HelperFunctions";

const OptionalServices = ({
  data,
  context,
  optionalServices,
  dealType,
  currentSubscriber,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [allOptionalServices, setOptionalServices] = useState(<div />);
  const [showComponent, setShowComponent] = useState(
    checkSectionValid(optionalServices),
  );

  useEffect(() => {
    if (showComponent || currentSubscriber !== undefined) {
      if (currentSubscriber === undefined) {
        setOptionalServices(setDetails(optionalServices?.services, dealType));
      } else {
        var optionalServicesBySubscriber = optionalServices?.services?.filter(
          (service) => service.subscriber === currentSubscriber,
        );
        setShowComponent(true);
        setOptionalServices(setDetails(optionalServicesBySubscriber, dealType));
        if (
          !optionalServicesBySubscriber ||
          optionalServicesBySubscriber?.length === 0
        ) {
          setShowComponent(false);
        }
      }
    }
  }, [optionalServices, currentSubscriber]);

  const cardTitle =
    data.optionalServicesTopic.value === ""
      ? "השירותים שלך"
      : data.optionalServicesTopic.value;

  return showComponent ? (
    <div className="block-frame p-2">
      <CollapseButton
        cardTitle={cardTitle}
        setIsOpen={setIsOpen}
        isOpen={isOpen}
      />
      {isOpen && (
        <div className="block-frame__container">{allOptionalServices}</div>
      )}
    </div>
  ) : null;
};

function setDetails(optionalServices, dealType) {
  const isDealTypeChangeOrReplace =
    dealType === transactionType.Replace || dealType === transactionType.Change;

  return (
    <React.Fragment>
      <hr />
      {optionalServices?.map((service, idx) => {
        let rowStyle =
          "block-frame__row" +
          (isDealTypeChangeOrReplace ? " with-status-layout" : "");

        if (
          !(
            checkRegularPayment(service.priceCycles) ||
            service.onePaymentCharge !== ""
          )
        ) {
          rowStyle += " block-frame__row--1";
        }

        const isCancelled =
          service.action.toLowerCase() === "remove" ||
          service.action.toLowerCase() === "disconnect";
        const isExists = service.action.toLowerCase() === "exists";

        return (
          <div
            className="block-frame__list-info"
            key={idx.toString() + service.name}
          >
            <div className={rowStyle}>
              <div className="block-frame__status-holder">
                {isDealTypeChangeOrReplace && (
                  <p
                    className={
                      "block-frame__status block-frame__status" +
                      setStatusStyle(service.action)
                    }
                  >
                    {actionDescription[service.action]}
                  </p>
                )}
                <label
                  className={
                    isCancelled ? "cancelled" : isExists ? "isExists" : ""
                  }
                >
                  {service.name}
                </label>
              </div>
              {setPriceCyclesDescription(
                service.priceCycles,
                service.onePaymentCharge,
                isCancelled,
              )}
            </div>
          </div>
        );
      })}
    </React.Fragment>
  );
}

export default OptionalServices;
